import * as React from 'react'
import styled from 'styled-components/macro'
import BodyScroll from './BodyScroll'
import * as Ariakit from '@ariakit/react'

const StyledDialog = styled(Ariakit.Dialog)`
  position: fixed;
  z-index: 19900410;
  left: 50%;
  margin-left: -50px;
  top: 50%;
  margin-top: -50px;
  padding: 1em;
  border-radius: 0.25em;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.13);
  background-color: #ffffff;
`
const StyledTimeoutDialog = styled(Ariakit.Dialog)`
  position: fixed;
  width: 50%;
  z-index: 19900410;
  top: 41%;
  left: 25%;
  border-radius: 0.25em;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.13);
  background-color: #ffffff;
`

const StyledBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 199004;
`

function Dialog({
  children,
  hideOnEsc,
  timeout,
  ...dialog
}: Ariakit.DialogStore & {
  children: React.ReactNode
  'aria-label': string
  hideOnEsc?: boolean
  timeout?: boolean
}) {
  const isDialogOpen = dialog.useState('open')
  let styledComponent = (
    <StyledDialog hideOnInteractOutside={false} hideOnEscape={hideOnEsc} backdrop={<StyledBackdrop />}>
      <BodyScroll scroll={!isDialogOpen} />
      {children}
    </StyledDialog>
  )

  if (timeout) {
    styledComponent = (
      <StyledTimeoutDialog hideOnInteractOutside={false} hideOnEscape={hideOnEsc} backdrop={<StyledBackdrop />}>
        <BodyScroll scroll={!isDialogOpen} />
        {children}
      </StyledTimeoutDialog>
    )
  }
  return <Ariakit.Portal>{styledComponent}</Ariakit.Portal>
}

export default Dialog
